import type { FirestoreContainer } from './FirestoreContainer.js';

import { createContainer } from '@elara/core/di';

import { createClientStoryModel } from '#models/StoryModel.js';

/**
 * Client-side Stories Container for dependency injection.
 * Exposes the Story model the trips-home rail and the story article read from.
 */
export function createStoriesContainer(firestore: FirestoreContainer) {
  const $stories = createContainer('stories').providedLazy('ClientStory', () => createClientStoryModel(firestore));
  return $stories;
}

export type $StoriesContainer = ReturnType<typeof createStoriesContainer>;
export type StoriesContainer = $StoriesContainer['use'];
